exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.display-center[data-v-d5480af2] {\n  display: flex;\n  align-items: center;\n}\n.custom-height[data-v-d5480af2] {\n  height: 96px !important;\n}\n.custom-distribution-date__head[data-v-d5480af2] {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  min-width: 50%;\n}\n", ""]);

// exports
